import history from '../history.js'

function setAdminLoggedOut () {
  window.localStorage.removeItem('adminToken')
  window.localStorage.removeItem('adminEmail')
  history.push('/admin/login')
}

export default setAdminLoggedOut
